import { render, staticRenderFns } from "./TelegramInput.vue?vue&type=template&id=648c0977&scoped=true"
import script from "./TelegramInput.vue?vue&type=script&lang=ts"
export * from "./TelegramInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c0977",
  null
  
)

export default component.exports